var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.989 7.48234C3.47186 8.95653 6.05794 10.9999 9.00015 10.9999C11.9424 10.9999 14.5279 8.95653 16.0108 7.48234C16.4019 7.09355 16.5981 6.89849 16.7226 6.51676C16.8115 6.2444 16.8115 5.75561 16.7226 5.48325C16.5981 5.10151 16.4019 4.90642 16.0108 4.51759C14.5279 3.0434 11.9424 1 9.00015 1C6.05794 1 3.47186 3.0434 1.989 4.51759C1.59761 4.90669 1.4019 5.10137 1.27733 5.48325C1.18848 5.75561 1.18848 6.2444 1.27733 6.51676C1.40191 6.89864 1.59761 7.09324 1.989 7.48234Z",
    stroke: "#2AEAFA",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 6C7.33333 6.92047 8.07953 7.66667 9 7.66667C9.92047 7.66667 10.6667 6.92047 10.6667 6C10.6667 5.07953 9.92047 4.33333 9 4.33333C8.07953 4.33333 7.33333 5.07953 7.33333 6Z",
    stroke: "#2AEAFA",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.8dec0d592c6cc186ec8b63cc64b4abee.svg";
export { ForwardRef as ReactComponent };